/**
 * jsonから値を取得して表示するパターン
 */
// import axios from 'axios'

// async function fetchData() {
//   const response = await axios.get('http://localhost:3000/assets/js/db/data.json')
//   const datas = response.data.data
//   const newDatas = [...datas]

//   return newDatas
// }

// async function init() {
//   const counters = document.querySelectorAll('.js-counter')
//   const counts = await fetchData()

//   counters.forEach((counter, index) => {
//     counter.textContent = '0'
  
//     const updateCounter = () => {
//       // const target = +counter.getAttribute('data-count')
//       const target = counts[index].count
//       const c = +counter.innerText
//       const increment = target / 50
    
//       if (c < target) {
//         counter.innerText = `${Math.ceil(c + increment)}`
//         setTimeout(updateCounter, 25)
//       }
//     }
  
//     updateCounter()
//   })
// }

// init()


/**
 * DOMから値を取得して表示するパターン
 */
export function counterAnimation() {
  const counters = document.querySelectorAll('.js-counter')
  if (counters.length === 0) { return }

  counters.forEach((counter, index) => {
    const target = +counter.textContent
    counter.textContent = '0'
  
    const updateCounter = () => {
      const c = +counter.innerText
      const increment = target / 50
    
      if (c <= target) {
        counter.innerText = `${Math.ceil(c + increment)}`
        setTimeout(updateCounter, 25)
      } else {
        counter.innerText = target
      }
    }
  
    updateCounter()
  })
}
